import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Select } from 'antd';
import FormItem from "components/fields/FormItem";
import { 
	getRegions, getProvinces, getMunicipalities, getBarangays, getNCRCities
} from "../../redux/psgcdata/psgcDataState";

const RegionProvinceBarangay = ({recordData, mode, form,
	getRegionList, getProvinceList, getNCRCityList, getMunicipalityList, getBarangayList,
	regions, provinces, municipalities, barangays, rules}) => {
	
	const [hideProvice, setHideProvince] = useState(false);
	
	const handleRegionChange = (value) => {
		form.setFieldsValue({
			...form.getFieldsValue(), 
			address_province_code: null, 
			address_municipality_code: null, 
			address_barangay_code: null
		});
		doGetRegionCityProvince(value);				
    };

	const doGetRegionCityProvince = (code) => {		
		if(code === '130000000'){
			setHideProvince(true);
			getNCRCityList(code);					
		}else{
			setHideProvince(false);
			getProvinceList(code);
		}	
	}

	const handleProvinceChange = (value) => {
		form.setFieldsValue({
			...form.getFieldsValue(), 
			address_municipality_code: null, 
			address_barangay_code: null
		});
		getMunicipalityList(value);
	}

	const handleMunicipalityChange = (value) =>{
		form.setFieldsValue({
			...form.getFieldsValue(), 
			address_barangay_code: null
		});
		getBarangayList(value);
	}

	useEffect(() => {
		getRegionList({});

		if(recordData?.address){
			if(recordData.address?.region_code){
				doGetRegionCityProvince(recordData.address?.region_code);							
			}
			if(recordData.address?.province_code){
				getMunicipalityList(recordData.address?.province_code);
			}
			if(recordData.address?.municipality_code){
				getBarangayList(recordData.address?.municipality_code);
			}
		}

	}, [recordData, getRegionList]);
	
  	return (
		<div className="form-column-4">
			<FormItem 
				name="address_region_code"
				label="Region"
				rules={rules}
			>
				{mode === 'edit' ?
				<Select id="address_region_code"            		
					options={regions}
					showSearch
					allowClear={true}
					onChange={handleRegionChange}
				/>					
				: <label className="ps-3 dark:text-white">{recordData?.address?.region}</label>
				}	                
			</FormItem>
			<FormItem hidden={hideProvice}
				name="address_province_code"
				label="Province"	
				rules={rules}			
			>
				{mode === 'edit' ?
				<Select id="address_province_code"            		
					options={provinces}
					showSearch
					allowClear={true}
					onChange={handleProvinceChange}
				/>					
				: <label className="ps-3 dark:text-white">{recordData?.address?.province}</label>
				}	                
			</FormItem>
			<FormItem 
				name="address_municipality_code"
				label="Municipality/City"
				rules={rules}
			>
				{mode === 'edit' ?
				<Select id="address_municipality_code"            		
					options={municipalities}
					showSearch
					allowClear={true}
					onChange={handleMunicipalityChange}
				/>
				: <label className="ps-3 dark:text-white">{recordData?.address?.municipality}</label>
				}	                
			</FormItem>	
			<FormItem 
				name="address_barangay_code"
				label="Barangay"
				rules={rules}
			>
				{mode === 'edit' ?
				<Select id="address_barangay_code"            		
					options={barangays}
					showSearch
					allowClear={true}
				/>
				: <label className="ps-3 dark:text-white">{recordData?.address?.barangay}</label>
				}	                
			</FormItem>            
        </div>
  );
}

const mapStateToProps = (state) => ({
	regions: state.psgcData.regions?.items,
	provinces: state.psgcData.provinces?.items,
	municipalities: state.psgcData.municipalities?.items,
	barangays: state.psgcData.barangays?.items,
});

const mapDispatchToProps = (dispatch) => ({
	getRegionList: (data) => dispatch(getRegions(data)),
	getProvinceList: (data) => dispatch(getProvinces(data)),
	getMunicipalityList: (data) => dispatch(getMunicipalities(data)),
	getBarangayList: (data) => dispatch(getBarangays(data)),
	getNCRCityList: (data) => dispatch(getNCRCities(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RegionProvinceBarangay);